import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura'

export const RwiqhaTheme = definePreset(Aura, {
	components: {
		progressspinner: {
			colorScheme:{
				light: {
					root: {
						'color.1': '#027864',
						'color.2': '#86ead4',
						'color.3': '#898e87',
						'color.4': '#16433c' 
					}
				}
			}
		}
	}
})
